var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimespent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.4579 0 0 13.4579 0 30C0 46.5421 13.4579 60 30 60C46.5421 60 60 46.5421 60 30C60 13.4579 46.5421 0 30 0ZM30 57.6001C14.7815 57.6001 2.3999 45.2197 2.3999 30C2.3999 14.7815 14.7815 2.3999 30 2.3999C45.2197 2.3999 57.6001 14.7815 57.6001 30C57.6001 45.2197 45.2197 57.6001 30 57.6001Z",
    fill: "#508FD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 29.5031V13.2C31.2 12.5374 30.6625 12 30 12C29.3375 12 28.8 12.5374 28.8 13.2V29.9999C28.8 30.1558 28.8324 30.3118 28.8925 30.4583C28.9536 30.6047 29.0411 30.7378 29.1516 30.8483L38.7515 40.4482C38.9856 40.6823 39.2929 40.7997 39.5999 40.7997C39.9072 40.7997 40.2145 40.6823 40.4483 40.4482C40.9177 39.9791 40.9177 39.2208 40.4483 38.7514L31.2 29.5031Z",
    fill: "#508FD9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimespent);
export default __webpack_public_path__ + "static/media/timespent.a1af5c8a98f75071e60a6829943c18c8.svg";
export { ForwardRef as ReactComponent };